import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ContributorTableState {
  selectedContributors: any;
  setSelectedContributors: (selectedContributors: any) => void;
  filteredContributors: any;
  setFilteredContributors: (filteredContributors: any) => void;
  isContributorsEmpty: boolean;
  setIsContributorsEmpty: (isContributorsEmpty: boolean) => void;
}

export const useContributorTableStore = create<ContributorTableState>()(
  persist(
    (set) => ({
      selectedContributors: [],
      filteredContributors: [],
      isContributorsEmpty: false,
      setSelectedContributors: (selectedContributors) =>
        set({ selectedContributors }),
      setFilteredContributors: (filteredContributors) =>
        set({ filteredContributors }),
      setIsContributorsEmpty: (isContributorsEmpty) =>
        set({ isContributorsEmpty }),
    }),
    {
      name: 'contributor-table-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useContributorTableStore;
